// ═══════════════════════════════════════════════════════════════════════════════
// System message types (broadcast + future event instances)
// ═══════════════════════════════════════════════════════════════════════════════
export const SYSTEM_MESSAGE_SOURCE = {
    BROADCAST: 'broadcast',
    EVENT: 'event',
};
export const SYSTEM_MESSAGE_TRIGGER_TYPE = {
    NONE: 'none',
};
export const SYSTEM_MESSAGE_MATCH_MODE = {
    AND: 'and',
    OR: 'or',
};
export const SYSTEM_MESSAGE_NOTIFICATION_STATUS = {
    NONE: 'none',
    PENDING: 'pending',
    SENT: 'sent',
    CANCELLED: 'cancelled',
};
//# sourceMappingURL=systemMessage.js.map